/**
 * CreateGroupHeader Component
 * Handles the header section with navigation and title
 */

import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft } from 'lucide-react';

interface CreateGroupHeaderProps {
  onBack: () => void;
  isEditMode: boolean;
  isDuplicateMode: boolean;
}

export const CreateGroupHeader: React.FC<CreateGroupHeaderProps> = ({
  onBack,
  isEditMode,
  isDuplicateMode
}) => {
  const getTitle = () => {
    if (isEditMode) return 'Edit Group';
    if (isDuplicateMode) return 'Duplicate Group';
    return 'Create Group';
  };

  return (
    <div className="bg-purple-100 border-b border-purple-200">
      <div className="flex items-center justify-between px-6 py-4">
        <div className="flex items-center space-x-4">
          <Button
            onClick={onBack}
            variant="ghost"
            size="sm"
            className="text-purple-600 hover:text-purple-900 hover:bg-purple-200"
          >
            <ChevronLeft className="h-4 w-4 mr-1" />
            Back
          </Button>
          <div className="h-6 w-px bg-purple-300" />
          <img
            src="/lovable-uploads/6823d161-b5be-421b-863a-12eaf2ea796e.png"
            alt="HBox Logo"
            className="h-8 w-auto"
          />
          <div className="text-xl font-semibold text-purple-900">
            <div>PEP</div>
            <div>VPE Admin Dashboard - {getTitle()}</div>
          </div>
        </div>
      </div>
    </div>
  );
};